import { makeModuleI18nSelector } from "@client/content/selectors";
import { type i18n } from "@client/types";
import { uniq } from "lodash";
import { createSelector } from "reselect";
import {
  localStateCurrentSelector,
  localStateHasMoreSelector,
  localStateItemsSelector,
  localStateRewardsSelector
} from "../selectors";
import { type Leaderboard } from "../types";

export const makeTopTitleSelector = () => {
  const i18nSelector = makeModuleI18nSelector();

  return createSelector(
    [i18nSelector, localStateCurrentSelector],
    (i18n: i18n, current: Leaderboard.Item): string | null => {
      if (!current || current.type === "incentive") return null;

      if (current.position === 1) return i18n.infoCurrentFirstPosition;
      if (current.requiredScore === 0) return i18n.infoCurrentNoVotes;

      const msg = current.requiredScore === 1 ? i18n.infoCurrentPositionVote : i18n.infoCurrentPositionVotes;
      return msg
        .replace("{POSITION}", current.position.toString())
        .replace("{VOTES}", current.requiredScore.toString());
    }
  );
};

export const makeRewardsSelector = () =>
  createSelector(
    [localStateHasMoreSelector, localStateItemsSelector, localStateRewardsSelector],
    (hasMore, items: Leaderboard.Item[], rewards: Leaderboard.Reward[]): Leaderboard.Reward[] => {
      let finalRewards: Leaderboard.Reward[] = [];
      if (hasMore) {
        const rewardIds = uniq(items.filter((x) => x.rewardId).map((x) => x.rewardId));
        finalRewards = rewardIds.map((x) => rewards.find((r) => r.id === x)!);
      } else {
        finalRewards = rewards.slice();
      }

      return finalRewards.sort((a, b) => a.sortOrder - b.sortOrder);
    }
  );
